import { useQuery } from 'react-query';
import { CoreApi } from 'utils/core-api';
import { API_ENDPOINTS } from 'utils/endpoints';

const MenusService = new CoreApi(API_ENDPOINTS.MEGA_MENU);

export const fetchSettings = async () => {
    const Menudata = await MenusService.findAll();
    return Menudata?.data ?? [];
};
export const useMegaMenuQuery = () => {
    return useQuery(API_ENDPOINTS.MEGA_MENU, fetchSettings);
};
